const analytics = [
  {
    tabName: "Sales Performance",
    page: [],
    path: "/analytics/sales-performance",
    authority: "PORTAL",
    rolePermission: "ANALYTICS_SALES_PERFORMANCE",
  },
  {
    tabName: "Sales Achievement",
    page: [],
    path: "/analytics/sales-achievement",
    authority: "PORTAL",
    rolePermission: "ANALYTICS_SALES_ACHIEVEMENT",
  },
  {
    tabName: "Referrer Performance",
    page: [],
    path: "/analytics/referrer-performance",
    authority: "PORTAL",
    rolePermission: "ANALYTICS_REFERRER_PERFORMANCE",
  },
  {
    tabName: "Referrer Transaction Volume",
    page: [],
    path: "/analytics/referrer-transaction-volume",
    authority: "PORTAL",
    rolePermission: "ANALYTICS_REFERRER_TRANSACTION_VOLUME",
  },
  {
    tabName: "Transaction Activity",
    page: [],
    path: "/analytics/transaction-activity",
    authority: "PORTAL",
    rolePermission: "ANALYTICS_TRANSACTION_ACTIVITY",
  },
  {
    tabName: "Low Activity Merchant",
    page: [],
    path: "/analytics/low-activity-merchant",
    authority: "PORTAL",
    rolePermission: "ANALYTICS_LOW_ACTIVITY_MERCHANT",
  },
  {
    tabName: "Merchant Detail",
    page: [],
    path: "/analytics/transaction-activity/merchant-detail",
    authority: "PORTAL",
    rolePermission: "ANALYTICS_TRANSACTION_ACTIVITY",
    showInSidebar: false,
  },
  {
    tabName: "Data Overview & Export",
    page: [],
    path: "/analytics/data-overview-and-export",
    authority: "PORTAL",
    rolePermission: "ANALYTICS_DATA_OVERVIEW_AND_EXPORT",
  },
  // {
  //   tabName: "Data Overview & Export",
  //   page: [],
  //   path: "/analytics/data-overview-and-export",
  //   authority: "PORTAL",
  // },
  {
    tabName: "SME Usage",
    page: [],
    path: "/analytics/sme-usage",
    authority: "PORTAL",
    rolePermission: "ANALYTICS_SME_USAGE",
    devEnv: true,
  },
  // {
  //   tabName: "Daily Merchant Info",
  //   page: [],
  //   path: "/analytics/daily-merchant-info",
  //   authority: "PORTAL",
  //   devEnv: true,
  // },
  // {
  //   tabName: "Transaction by Card Type",
  //   page: [],
  //   path: "/analytics/transaction-by-card-type",
  //   authority: "PORTAL",
  //   devEnv: true,
  // },
  // {
  //   tabName: "Employee",
  //   page: [],
  //   path: "/analytics/employee",
  //   authority: "PORTAL",
  //   devEnv: true,
  // },
  // {
  //   tabName: "Low Activity Merchant (Data lake)",
  //   page: [],
  //   path: "/analytics/low-activity-merchant-data-lake",
  //   authority: "PORTAL",
  //   devEnv: true,
  // },
  {
    tabName: "System Statistics",
    page: [],
    path: "/analytics/system-statistics",
    authority: "PORTAL",
    rolePermission: "ANALYTICS_SYSTEM_STATISTICS",
    devEnv: true,
  },
  {
    tabName: "Weekly Sales Statistics",
    page: [],
    path: "/analytics/weekly-statistics",
    authority: "PORTAL",
    rolePermission: "ANALYTICS_SALES_STATISTICS",
  },
  {
    tabName: "Summary Statistics",
    page: [],
    path: "/analytics/summary",
    authority: "PORTAL",
    rolePermission: "ANALYTICS_SUMMARY_STATISTICS",
  },
  {
    tabName: "Internal/External Statistics",
    page: [],
    path: "/analytics/internal-external",
    authority: "PORTAL",
    rolePermission: "ANALYTICS_INTERNAL_EXTERNAL_STATISTICS",
  },
  {
    tabName: "Salesperson Statistics",
    page: [],
    path: "/analytics/salesperson",
    authority: "PORTAL",
    rolePermission: "ANALYTICS_SALESPERSON_STATISTICS",
  },
];

export default analytics;
